import PropTypes from "prop-types";

function ErrorBanner({ children }) {
  return (
    <div className="bg-red-200 dark:bg-red-400 p-2 text-center">
      <span className="text-xs text-red-500 dark:text-red-50">{children}</span>
    </div>
  );
}

ErrorBanner.propTypes = {
  children: PropTypes.node,
};

export default ErrorBanner;
